import CityPageTemplate from "../city-template/CityPageTemplate";
import { mansfieldConfig } from "./data";

export default function MansfieldPage() {
  return <CityPageTemplate config={mansfieldConfig} />;
}